import React, { Component } from 'react';
import {isEmpty, map} from "lodash";
import moment from "moment-timezone";
import {message} from "antd";
import CustomMap from "../Common/CustomMap";
import Loader from "../../../../Common/Component/Loader";

class AccountOverview extends Component {
  state = {
    loader: false,
    proposalList: {},
    quoteDetail: {}
  }

  componentDidMount = () => {
    const { getCommercialProposal, getQuoteById, quoteId } = this.props;
    this.setState({loader: true})
    getQuoteById && getQuoteById(quoteId) // get quote detail
    getCommercialProposal && getCommercialProposal({commercial_quote__uuid: quoteId, page: 1, page_size: 1}) // get one proposal
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {proposalList} = this.state;
    this.setState({loader: false});
    // get commercial user
    if (Object.keys(nextProps?.CommercialProposal?.getCommercialProposal).length > 0
      && JSON.stringify(nextProps?.CommercialProposal?.getCommercialProposal) !== JSON.stringify(proposalList)) {
      this.setState({proposalList: nextProps?.CommercialProposal?.getCommercialProposal});
    }

    // get quote detail
    if (Object.keys(nextProps?.CommercialProposal?.getQuoteDetail).length > 0
      && JSON.stringify(nextProps?.CommercialProposal?.getQuoteDetail) !== JSON.stringify(this.state.getQuoteDetail)) {
      this.setState({quoteDetail: nextProps?.CommercialProposal?.getQuoteDetail})
    }

  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // render primary info
  renderPrimaryInfo = () => {
    const {quoteDetail} = this.state;
    const phone_number = quoteDetail?.phone_numbers?.find((obj) => obj.primary === true)
    const account_holder = {user_name: quoteDetail?.community_name, phone_number: phone_number?.phone, email: quoteDetail?.email_address};

    return (
      <div className="card">
        <div className="card-title">
          <h5>Primary Information</h5>
        </div>
        <div className="card-body">
          {!isEmpty(account_holder) ?
            <div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Account Holder:</b>
                </div>
                <div className="value">
                  <b>{account_holder?.user_name}</b>
                </div>
              </div>
              <div className="mb-10">{account_holder?.phone_number ? `+1 ${this.formatPhoneNumber(account_holder?.phone_number)} (Primary)` : ''}</div>
              <div>{`${account_holder?.email} (Primary)`}</div>
            </div> : ''
          }
        </div>
      </div>
    )
  };

  // render proposal overview
  renderProposalOverview = (item) => {
    const address = item?.commercial_quote?.address || {};
    let total = 0;
    map(item?.inner_proposals, (x) => {
      map(x?.line_items, (obj) => total+= parseInt(obj.total))
    })
    let _markers = [], multiple_locations = item?.multiple_locations
    if (multiple_locations) {
      let locations = multiple_locations?.split('MULTIPOINT')[1]
      locations = locations?.trim().substr(1, locations.trim().length - 2)
      let temp = locations?.split(', ')
      map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
    } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
      _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
    }

    return (
      <React.Fragment>
        {!isEmpty(_markers) ? <div className="map">
          <CustomMap markers={_markers} />
        </div>: ''}
        <div className="plr-15">
          <div style={{marginTop: "20px"}}>Zip code: <span style={{fontWeight: "bold"}}>{item.commercial_quote.zip_code}</span> </div>
          <span className="snum">
            {!isEmpty(item?.proposal_number) ? item?.proposal_number : '-'}
          </span>
          <h5 className="sadd">{!isEmpty(address) ? `${address?.address}, ${address?.city}, ${address?.state} ${address?.zip_code}` : '-'}</h5>
          <span className="altude">{!isEmpty(address?.geo_location?.latitude) ? `${address?.geo_location?.latitude}, ${address?.geo_location?.longitude}` : ``}</span>
          <div className="active_service_list">
            <div className="flex">
              <div>
                <b>Proposal Date</b>
                <span>{item?.proposal_date ? moment(item?.proposal_date).format('ddd, MMM DD') : item?.commercial_quote?.proposal_due ? moment(item?.commercial_quote?.proposal_due).format('ddd, MMM DD') : ''}</span>
              </div>
              <div>
                <b>Amount</b>
                <span>${total}</span>
              </div>
              <div>
                {/*<b>Probability</b>
                <span>-</span>*/}
              </div>
            </div>
          </div>
        </div>
        <div className="total flex plr-15">
          <h5>Total per visit</h5>
          <h5>${total}</h5>
        </div>
      </React.Fragment>
    )
  }

  // render proposal detail
  renderProposalDetail = (item, index) => {
    return (
      <React.Fragment key={`service${index}`}>
        <div className="card">
          <div className="card-title flex">
            <h5>Proposals</h5>
            <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View Proposals</button>
          </div>
          <div className="card-body p-0">
            {this.renderProposalOverview(item)}
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const {loader, proposalList} = this.state;

    return (
      <div className="block-row">
        <div className="card-row hide-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {map(proposalList?.results, this.renderProposalDetail)}
          </div>
          <div className="card-col"/>
          <div className="card-col"/>
        </div>
        <div className="card-row show-lg">
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {map(proposalList?.results, this.renderProposalDetail)}
          </div>
          <div className="card-col"/>
        </div>
      </div>
    );
  }
}

export default AccountOverview;
